import { Controller } from '@hotwired/stimulus'
import { debounce } from 'lodash'

export default class extends Controller {

  static targets = [
    'container',
    'input',
  ]

  initialize() {
    this.checkoutContainer = document.querySelector('#checkout-container')
    this.updateNotes = debounce(this.updateNotes, 100)
  }

  connect() {
    this.checkoutContainer = document.querySelector('#checkout-container')
    this.checkoutContainer.addEventListener('orderLoaded', this.onInitialOrderLoad, { once: true })
  }

  onInitialOrderLoad = ({ detail }) => {
    const orderNotes = detail.order.notes;
    if (orderNotes) {
      this.inputTarget.value = orderNotes
    }
  }

  updateNotes = _event => {
    const detail = { notes: this.inputTarget.value }
    const noteUpdateEvent = new CustomEvent('noteUpdate', { detail })
    this.checkoutContainer.dispatchEvent(noteUpdateEvent)
  }

  clearInput = _event => {
    this.inputTarget.value = null
    this.updateNotes(null)
  }
}
